let pathnameListeners: ((pathname: string) => void)[] = [];

/**
 * Patches history.pushState and history.replaceState to inform the location listeners when they're called
 */
function installPatch() {
  installFuncPatch("pushState");
  installFuncPatch("replaceState");
}

// Monkey patch when on browser
if (typeof window !== "undefined") {
  installPatch();
}

/**
 * Patches the given history[funcName] function to inform the routers when they're called
 */
function installFuncPatch(funcName: string) {
  const history = window.history;
  const origFunc = history[funcName];
  history[funcName] = patch;

  async function patch(data, title, url) {
    const originalPathname = document.location.pathname;

    // Forward requests to the native function, even if they came as a result from calling router.replace()
    // That way we ensure we don't lose any data that router may decide to set.
    origFunc.call(this, data, title, url);

    if (document.location.pathname !== originalPathname) {
      pathnameChanged(document.location.pathname);
    }
  }
}

type UnsubscribeCallback = () => void;

type PathnameListener = (pathname: string) => void;

export function subscribeToPathname(
  listener: PathnameListener
): UnsubscribeCallback {
  pathnameListeners.push(listener);

  return () => {
    pathnameListeners = pathnameListeners.filter((l) => l !== listener);
  };
}

function pathnameChanged(pathname: string) {
  pathnameListeners.forEach((listener) => {
    try {
      listener(pathname);
    } catch (e) {
      console.log(`Encountered error firing history changed event`, e);
    }
  });
}
